module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjkiIGhlaWdodD0iOTAiIHZpZXdCb3g9IjAgMCA2OSA5MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMjIsIDI3KSIgZD0iTTExLjUyNTYgMC44MDc2MTdIMEwxMi44MDYyIDE4LjE4NzVMMCAzNS41NjczSDExLjUyNTZMMjQuMzMxOCAxOC4xODc1TDExLjUyNTYgMC44MDc2MTdaIiBmaWxsPSIjMDU5QkNBIi8+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/arrow1.svg
// module id = 6jrk
// module chunks = 1